/** Exact app-owned topology activated after a contract Hub is attested. */
export const HUB_LAYOUT_V1 = Object.freeze({
  shellClass: 'fmp-hub',
  shellModifierClass: 'fmp-hub--layout-v1',
  carrierModifierClass: 'fmp-widget-scope--hub-layout-v1',
  headerClass: 'fmp-hub__header',
  navClass: 'fmp-hub__nav',
  indexLinkClass: 'fmp-hub__index-link',
  shellSelector: '.fmp-hub.fmp-hub--layout-v1',
});

/**
 * The only standalone root admitted by the CSS isolation guard.
 */
export const HUB_LAYOUT_V1_SHELL_SELECTOR = HUB_LAYOUT_V1.shellSelector;

/** Exact app-rendered discovery link admitted beneath an activated Hub shell. */
export const HUB_LAYOUT_V1_INDEX_LINK_SELECTOR = `${HUB_LAYOUT_V1_SHELL_SELECTOR} > .${HUB_LAYOUT_V1.navClass} .${HUB_LAYOUT_V1.indexLinkClass}`;
